var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gjkkf8li2a",
    d: "M0 0h15v15H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fgxbmslytc",
    d: "M0 0h12v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8il3bhrf3e",
    d: "M0 0h4v5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t9mopfe8yb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gjkkf8li2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15",
    fill: "#D8D8D8",
    mask: "url(#t9mopfe8yb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a7 7 0 1 1 0 14 7 7 0 0 1 0-14",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jphnx6skcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fgxbmslytc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.621.162A5.999 5.999 0 1 1 7.38 11.838 5.999 5.999 0 0 1 4.62.162",
    fill: "#D8D8D8",
    mask: "url(#jphnx6skcd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 50a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11M23.344 67.778a4.499 4.499 0 1 1 8.312 3.444 4.499 4.499 0 0 1-8.312-3.444M45.001 68.9a4 4 0 1 1 7.998.2A4 4 0 0 1 45 68.9M65 52a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67 31)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b57q2edh0f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8il3bhrf3e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 0C-.667 0-.667 5 2 5s2.667-5 0-5",
    fill: "#D8D8D8",
    mask: "url(#b57q2edh0f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 16c2 0 2-3 0-3s-2 3 0 3",
    fill: "#D8D8D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.f835df07c6287d19db480503fec19956.svg";
export { ForwardRef as ReactComponent };